import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { EventCategoryId } from "@/types/common/ids";

const baseEndPhoningCallReasonDtoSchema = z.object({
  id: branded.eventCategoryId,
  name: z.string(),
});

// zod recursive type
// see https://v3.zod.dev/?id=recursive-types
interface TBaseEndPhoningCallReasonDto {
  id: EventCategoryId;
  name: string;
  children: TBaseEndPhoningCallReasonDto[];
}

interface TBaseEndPhoningCallReasonDtoInput {
  id: number;
  name: string;
  children: TBaseEndPhoningCallReasonDtoInput[];
}

export const endPhoningCallReasonDtoSchema: z.ZodType<
  TBaseEndPhoningCallReasonDto,
  z.ZodTypeDef,
  // Since 'EventCategoryId' is a branded type (input number, output T), we need to provide a custom input type for zod
  TBaseEndPhoningCallReasonDtoInput
> = baseEndPhoningCallReasonDtoSchema.extend({
  children: z.lazy(() => endPhoningCallReasonDtoSchema.array()),
});

export const endPhoningCallTypeDtoSchema = z.object({
  id: branded.callTypeId,
  name: z.string(),
});

export const endPhoningReasonsDtoSchema = z.object({
  callReasons: z.array(endPhoningCallReasonDtoSchema),
  callTypes: z.array(endPhoningCallTypeDtoSchema),
});

export type TEndPhoningCallTypeDtoSchema = z.infer<typeof endPhoningCallTypeDtoSchema>;
export type TEndPhoningCallReasonDtoSchema = z.infer<typeof endPhoningCallReasonDtoSchema>;
export type TEndPhoningReasonsDtoSchema = z.infer<typeof endPhoningReasonsDtoSchema>;
